import React, { useCallback, useEffect, useState } from "react";
import './profile-setup.css'
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { IconContext } from 'react-icons';
import csLogo from '../../assets/images/cybersquare_logo.png'
import { useLocation, useNavigate } from "react-router-dom";
import { get_profile_details, activateUserAccount } from "../../services/login-api.js";
import ProfileSetupModal from "../modal/profileSetup-modal.js";
import CutomStatus from "./profile-setup-status.js";
import { useForm } from "react-hook-form";
import infoIcon from '../../assets/images/info-icon.svg'
import PhoneInput from 'react-phone-input-2'
// import googleIcon from '../../assets/images/google_icon.png';
// import { global_var } from "../../../src/services/login-config.js";
// import { setCompanyDetails } from '../../../src/utils/setCompanyDetails.js';

const CompanyRegistration = () => {

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [IsStatusVisible, setIsStatusVisible] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [signupStatus, setStatus] = useState(200);
    const [mobileInfo, setMobileInfo] = useState(false)
    const [mobileNumber, setMobileNumber] = useState({ dialCode: '+91', number: '' });
    const [MobilesSreenMobileInfo, setMobileScreenMobileInfo] = useState('')

    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const userLoginId = queryParams.get('userLoginId');

    const form = useForm({});
    const { register, handleSubmit, reset, formState, watch } = form
    const { errors } = formState;

    const pswd = watch('password', '');
    const confirmPwd = watch('confirmPswd', '');

    // const [companyName, setCompanyName] = useState('');
    // const [favIcon, setFavicon] = useState(null);

    const getUserProfile = useCallback(async (userLoginId) => {
        try {
            const response = await get_profile_details({ 'userLoginId': userLoginId });
            // Handle the response here
            if (response.data.statusCode === 200) {
                if (response.data.profile) {
                    reset({
                        username: response.data.profile[0].userName,
                        teachername: response.data.profile[0].firstName
                    })
                } else {
                    setModalMessage("Your account details could not be found. Please contact the administrator for assistance.");
                    setIsModalVisible(true);
                }
            } else {
                setModalMessage("Your account has already been updated. Please try to log in.");
                setIsModalVisible(true);
            }
        } catch (error) {
            if (error.response) {
                setModalMessage("Your account has already been updated. Please try to log in.");
                setIsModalVisible(true);
            }
        }
    }, [reset])

    useEffect(() => {
        // document.title = companyName;
        // if (favIcon) {
        //     const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        //     link.type = 'image/x-icon';
        //     link.rel = 'shortcut icon';
        //     link.href = favIcon;
        //     document.head.appendChild(link);
        //   }
        if (userLoginId) {
            getUserProfile(userLoginId)

        } else {
            navigate('/login')
        }

    }, [userLoginId, getUserProfile, navigate]);


    const togglePasswordVisibility = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword((prevShowPassword) => !prevShowPassword)
    }
    const handleModalClose = () => {
        setIsModalVisible(false);
        navigate('/login');
    };

    const handleCutomStatusResponse = (e) => {
        setIsStatusVisible(e.IsStatusVisible)
    }

    const handleMobileInput = (value, data) => {
        const obj = {
            dialCode: data['dialCode']
        }
        const number = value.startsWith(data['dialCode']) ? value.slice(data['dialCode'].length) : value;
        obj['number'] = number
        setMobileNumber(obj)
    }


    const onSubmit = async (data) => {
        try {

            let updateObj = {
                'userloginid': userLoginId,
                'userName': data['username']
            };

            if (data['teachername'] === '') {
                return
            }else{
                updateObj['firstName'] = data['teachername']
            }

            if (data['password'] && data['confirmPswd']){
                if(data['password'] === data['confirmPswd']) {
                    updateObj['password'] = data['password']
                }else{
                    return
                }
            }else{
                return
            }

            if(data['gender']){
                updateObj['gender'] = data['gender']
            }

            if(data['dob']){
                updateObj['dob'] = data['dob']
            }
            if(mobileNumber.number){
                updateObj['mobileNumber'] = {
                    'number' : mobileNumber.number   
                }
                if(mobileNumber.dialCode){
                    updateObj['mobileNumber']['dialCode'] = '+' + mobileNumber.dialCode
                }
            }
            const response = await activateUserAccount(updateObj);
            // Handle the response here
            if (response.data.statusCode === 200) {
                //re call comany details to set
                // if (window.location.host.split(".").length > 2) {
                //     let domainName = window.location.host.split('.')[0];
                //     getCompanyDetails(domainName).then((response) => {
                //         const data = JSON.parse(response);
                //         setCompanyDetails(data, global_var, setCompanyName, setFavicon);
                //     });
                // }
                //re call comany details to set
                setModalMessage("Your account is updated. Please try to log in.");
                setIsStatusVisible(true);
                setStatus(200)
            } else {
                setStatus(401)
                setIsStatusVisible(true)
            }


        } catch (error) {
            setStatus(500)
            setModalMessage("An error occurred. Please contact the administrator for assistance.");
            setIsStatusVisible(true);
        }
    };


    return (
        <div className='container-fluid'>
            <div className='row main-background-profileSetup'>
                <div className='col-12 d-flex justify-content-center align-items-center' style={{ padding: '20px 0px' }}>
                    {!IsStatusVisible ? (

                        <div className='col-md-6 col-12 p-4 rounded-4 form'>
                            <div className="col-12 mt-0" style={{ display: 'flex', justifyContent: 'center' }}>
                                <img src={csLogo} alt="cs logo" style={{ width: '305px' }} />
                            </div>
                            <div className=" mt-2" style={{ display: 'flex', justifyContent: 'center' }}>
                                <h3 style={{fontFamily: 'Poppins', fontSize: '16px',textAlign: 'center' }}>You Can Create Your Admin Account Here</h3>
                            </div>
                            

                            {/* registration Form */}

                            <form data-testid='profileForm' className="row mt-4" onSubmit={handleSubmit(onSubmit)}>

                                        <div className="col-1"></div>
                                        <div className="form-group mb-md-3 mb-4 col-10">
                                            <label htmlFor="teachername" className='pb-3 pb-md-2 custom-label' >Admin Name</label>
                                            <input
                                                type="text"
                                                id="teachername"
                                                className='new-form-control rounded-1 border-0 input-height'
                                                placeholder="Enter Admin Name"
                                                name="teachername"
                                                {...register('teachername', {
                                                    required: {
                                                        value: true,
                                                        message: 'Enter your name to proceed'
                                                    }
                                                })}
                                            />
                                            <div className="error-message">{errors.teachername?.message}</div>
                                        </div>

                                        <div className="col-1"></div>

                                        <div className="col-1"></div>
                                        <div className="form-group mb-md-3 mb-4 col-10" >
                                            <label htmlFor="username" className='pb-3 pb-md-2 custom-label' >Email</label>
                                            <input
                                                type="text"
                                                id="username"
                                                className='new-form-control rounded-1 border-0 input-height'
                                                placeholder="Email"
                                                disabled
                                                name="username"
                                                {...register('username', {
                                                    required: {
                                                        value: true,
                                                        message: 'username is required to procceed'
                                                    }
                                                })}
                                            />
                                        </div>
                                        <div className="col-1"></div>

                                        <div className="col-1"></div>
                                        <div className="form-group mb-md-3 mb-3 col-10 col-sm-10">
                                            <label htmlFor="username" className='pb-3 pb-md-2 custom-label'>Phone Number</label>
                                            <img className="infoIcon d-none d-sm-inline-block" alt="info-icon" src={infoIcon} onClick={() => setMobileInfo(!mobileInfo)}/>
                                            {mobileInfo ? (
                                                <label htmlFor="username" className='pb-3 pb-md-2 info-label d-none d-sm-inline'>Enter your mobile number for OTP sign-in</label>
                                            ): (null)}
                                            <PhoneInput
                                                placeholder={'Enter Number'}
                                                value={
                                                    `+${mobileNumber.dialCode}${mobileNumber.number}`
                                                }
                                                containerClass={"form-group mb-md-3 mb-2 rounded-1 border-0 input-height "}
                                                inputStyle={{ width: '100%', height: '40px', boxShadow: '0 0 0 .05rem #f5692d', paddingLeft: '70px', border: 'none' }}
                                                inputProps={{
                                                    name: 'mobile',
                                                    autoFocus: false,
                                                }}
                                                onChange={(value, data) => handleMobileInput(value, data)}
                                            />
                                            <span className={`mobile-tooltip-text1 ${MobilesSreenMobileInfo ? 'active': ''}`}>Enter your mobile number for OTP sign-in</span>
                                        </div>
                                        <div className="col-1 d-sm-none">
                                            <img className="mobile-info-icon d-block d-sm-none" alt="mobile-info-icon" src={infoIcon} onClick={() => setMobileScreenMobileInfo(!MobilesSreenMobileInfo)} />
                                        </div>
                                        <div className="col-1"></div>

                                        <div className="col-1 d-none d-sm-inline"></div>
                                        <div className="form-group mb-md-3 mb-4 col-10">
                                            <label htmlFor="pswd" className='pb-3 pb-md-2 custom-label' >Password</label>
                                            <div className='input-group'>
                                                <input
                                                    type={showPassword ? 'text' : 'password'}
                                                    id='pswd'
                                                    className='new-form-control rounded-1 border-0 input-height'
                                                    placeholder="Enter password"
                                                    name="password"
                                                    {...register('password', {
                                                        required: {
                                                            value: true,
                                                            message: 'Enter your password to proceed.'
                                                        },
                                                        minLength: {
                                                            value: 8,
                                                            message: 'Password must be at least 8 characters'
                                                        },
                                                        pattern: {
                                                            value: /^(?=.*[0-9])(?=.*[!@#$%^&*])/,
                                                            message: 'Password must include at least one number and one special character.'
                                                        }
                                                    })}
                                                />

                                                {pswd.length > 0 && (
                                                    <div className='input-group-append'>
                                                        <IconContext.Provider value={{ size: '1.5em' }}>
                                                            <span className='input-group-text' onClick={togglePasswordVisibility} style={{ border: 'none', cursor: 'pointer', backgroundColor: 'transparent', marginLeft: '-37px', position: 'absolute', marginTop: '11px' }}>
                                                                {showPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                                                            </span>
                                                        </IconContext.Provider>
                                                    </div>
                                                )}
                                                <div className="error-message">{errors.password?.message}</div>
                                            </div>
                                        </div>
                                        <div className="col-1"></div>

                                        <div className="col-1"></div>
                                        <div className="form-group md-mb-4 mb-4 col-10">
                                            <label htmlFor="confirmPswd" className='pb-3 pb-md-2 custom-label' >Confirm Password</label>
                                            <div className='input-group'>
                                                <input
                                                    type={showConfirmPassword ? 'text' : 'password'}
                                                    id='confirmPswd'
                                                    className={`new-form-control rounded-1 border-0 input-height`}
                                                    placeholder='Enter password'
                                                    name="confirmPswd"
                                                    {...register('confirmPswd', {
                                                        required: {
                                                            value: true,
                                                            message: 'Confirm your password to proceed'
                                                        },
                                                        validate : value => value === pswd || 'The confirm password must match the password.'
                                                    })}
                                                />

                                                {confirmPwd.length > 0 && (
                                                    <div className='input-group-append'>
                                                        <IconContext.Provider value={{ size: '1.5em' }}>
                                                            <span className='input-group-text' onClick={toggleConfirmPasswordVisibility} style={{ border: 'none', cursor: 'pointer', backgroundColor: 'transparent', marginLeft: '-37px', position: 'absolute', marginTop: '11px' }}>
                                                                {showConfirmPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                                                            </span>
                                                        </IconContext.Provider>
                                                    </div>
                                                )}
                                                <div className="error-message">{errors.confirmPswd?.message}</div>
                                            </div>
                                        </div>
                                        <div className="col-1"></div>

                                        <div className="text-center mb-3 mb-md-2 mt-5 mt-md-4 col-12">
                                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                <div className="col-6">
                                                    <button type="submit" className="btn btn-warning form-control" style={{
                                                        backgroundColor: "#FF0000",
                                                        color: "white",
                                                        borderRadius: "10px",
                                                        display: "block",
                                                        boxShadow: errors
                                                            ? "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.1)"
                                                            : "0 4px 6px rgba(255, 110, 98, 0.5), 0 1px 3px rgba(255, 110, 98, 0.5)",
                                                        height: '50px'
                                                    }} data-testid='signInButton'>Sign Up </button>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <div className="col-12 mt-md-2">
                                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                <div className="lined-text-container col-10">
                                                    <span className="lined-text">Or</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                <div className="col-7">
                                                    <button type="button" className='google-btn mt-4'>
                                                        <img src={googleIcon} alt="google icon" className='icon img-google' />
                                                        <span className='responsive-google-text' style={{ fontFamily: 'Poppins', fontWeight: 'bold' }}>Sign up with Google</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div> */}
                            </form>
                        </div>
                    ) : (
                        <CutomStatus
                            status={signupStatus}
                            response={handleCutomStatusResponse}
                        />
                    )
                    }
                </div>
            </div>
            {/* Modal section */}
            <ProfileSetupModal
                visible={isModalVisible}
                onClose={handleModalClose}
                message={modalMessage} // Pass the message to the modal
            />
        </div>

    );

};

export default CompanyRegistration;